import styles from './ModalButtonsLinks.module.scss'
import { Icon } from '@/components'
import { yandexMetrika } from '@/helpers/yandexMetrika'
import { IModalButtonsLinks } from '@/components/SliderPromotions/components/ModalButtonsLinks/ModalButtonsLinks.interface'
import { ONELINK_MOBILE_APP } from '@/constants/links'

export const ModalButtonsLinks = ({ setOpenModalLinks, mobileApps }: IModalButtonsLinks) => {
  return (
    <div className={styles.modal}>
      <div className={styles.modal__wrapper}>
        <div className={styles.modal__content}>
          <h3 className={styles.modal__title}>Выберите платформу для&nbsp;скачивания</h3>
          <div onClick={() => setOpenModalLinks(false)} className={styles.modalCloseIcon}>
            <Icon name={'modal-close-icon'} />
          </div>
          <div className={styles.modal__containerButtonsLinks}>
            {mobileApps && (
              <a
                target="_blank"
                className={styles.buttonLink}
                href={mobileApps.rustore_link}
                onClick={yandexMetrika.reachGoalButtonClickGooglePlayNew}
              >
                <img src={'/images/RustoreButton.png'} alt={'rustore_link'} />
              </a>
            )}
            <a
              target="_blank"
              className={styles.buttonLink}
              href={ONELINK_MOBILE_APP}
              onClick={() => {}} // todo метрика для рустора
            >
              <img src={'/images/GoogleButton.png'} alt={'android_link'} />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
